"use strict";
/**
 * Global fetch interceptor for session expiry detection.
 *
 * Wraps the native `fetch` so that ANY 401 response — whether from api.ts,
 * direct fetch() calls, or Leaflet tile requests — triggers the
 * "session-expired" event, which the SessionExpiredModal listens for.
 *
 * Must be imported early (e.g. in app-shell.tsx) so the wrapper is in place
 * before other code starts making requests.
 */
let sessionExpiredFired = false;
function fireSessionExpired() {
    if (sessionExpiredFired)
        return;
    sessionExpiredFired = true;
    window.dispatchEvent(new CustomEvent('session-expired'));
}
// Reset when the user successfully re-authenticates
window.addEventListener('session-restored', () => {
    sessionExpiredFired = false;
});
// Wrap the native fetch
const originalFetch = window.fetch.bind(window);
window.fetch = async function (...args) {
    const response = await originalFetch(...args);
    if (response.status === 401) {
        fireSessionExpired();
    }
    return response;
};
// Also listen for XMLHttpRequest 401s (covers XHR-based upload() in api.ts)
const originalXhrSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function (body) {
    this.addEventListener('loadend', function () {
        if (this.status === 401) {
            fireSessionExpired();
        }
    });
    return originalXhrSend.call(this, body);
};
